<template>
  <div class="w-full max-w-screen-xl mx-auto mb-10 overflow-hidden" :class="noHorizontalPadding ? 'px-0' : 'px-4'">
    <Carousel class="w-full relative overflow-hidden" :opts="{ loop: featuredShops.length > 1 }">
      <CarouselContent class="flex gap-x-4">
        <CarouselItem
          v-for="store in featuredShops"
          :key="store?.id"
          :class="[
            'flex-shrink-0',
            featuredShops.length === 1
              ? 'w-full max-w-full'
              : 'w-full sm:max-w-[360px] md:max-w-[480px] lg:max-w-[540px]',
          ]"
        >
          <FeaturedStoreCard
            :id="store?.id"
            :name="store?.name"
            :logo="store?.logo"
            :createdAt="store?.createdAt"
            :loading="loading"
            :domain="store?.domain"
          />
        </CarouselItem>
      </CarouselContent>

      <!-- Navigation buttons -->
      <CarouselPrevious
        class="flex items-center justify-center absolute top-1/2 -translate-y-1/2 left-4 text-white bg-black/40 rounded-full p-2 hover:bg-black/60 transition"
      >
        <ChevronLeft />
      </CarouselPrevious>
      <CarouselNext
        class="flex items-center justify-center absolute top-1/2 -translate-y-1/2 right-4 text-white bg-black/40 rounded-full p-2 hover:bg-black/60 transition"
      >
        <ChevronRight />
      </CarouselNext>

      <CarouselDotButtons class="mt-4 absolute bottom-4 left-1/2 -translate-x-1/2" selected-class="border-white" />
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import FeaturedStoreCard from '@/components/FeaturedStoreCard.vue';
import { Carousel, CarouselContent, CarouselDotButtons, CarouselItem } from '@/components/ui/carousel';
import { useShopsStore } from '@/stores/shop';
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import CarouselNext from './ui/carousel/CarouselNext.vue';
import CarouselPrevious from './ui/carousel/CarouselPrevious.vue';

withDefaults(
  defineProps<{
    noHorizontalPadding?: boolean;
  }>(),
  { noHorizontalPadding: true },
);

const shopsStore = useShopsStore();
const { featuredShops, loading } = storeToRefs(shopsStore);
</script>
